export default __webpack_public_path__ + "static/media/Quiz.fffa5d60.svg";